import React from "react";
import CtaPair from "@/components/site/CtaPair";

const BADGES = ["CLIA-Aligned", "CAP Checklist Mapped", "21 CFR Part 11", "ALCOA+ Audit Trail", "Human Review Required"];

export default function HomeHero() {
  return (
    <section className="bg-background">
      <div className="max-w-4xl mx-auto px-6 pt-16 pb-14 text-center">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-brand-navy leading-tight">
          Compliance documentation for CLIA- and CAP-regulated labs — without the enterprise price tag.
        </h1>
        <p className="mt-6 text-base sm:text-lg text-muted-foreground leading-relaxed max-w-3xl mx-auto">
          LabComplyx gives small and mid-size clinical laboratories a governed AI-assisted documentation layer for CAPA, deviations, SOP control, and inspection readiness. Every output requires human review. Every step produces an audit trail.
        </p>
        <div className="mt-8">
          <CtaPair />
        </div>
        <ul className="mt-8 flex flex-wrap justify-center gap-2">
          {BADGES.map((b) => (
            <li key={b} className="text-xs font-semibold px-3 py-1.5 rounded-full bg-accent text-accent-foreground border border-brand-teal/20">
              {b}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}